import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import '../../styles/components/modal.css';
export function Modal({ open, onClose, size = 'md', title, children, footer }) {
    const overlayRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const handler = (e) => { if (e.key === 'Escape')
            onClose(); };
        window.addEventListener('keydown', handler);
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', handler);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: "modal-overlay-ui", ref: overlayRef, onClick: (e) => { if (e.target === overlayRef.current)
            onClose(); }, children: _jsxs("div", { className: `modal-ui modal-${size}`, role: "dialog", "aria-modal": "true", children: [title && (_jsxs("div", { className: "modal-header-ui", children: [_jsx("h2", { className: "modal-title-ui", children: title }), _jsx("button", { className: "modal-close-ui", onClick: onClose, "aria-label": "Close", children: _jsxs("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), _jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })] }) })] })), _jsx("div", { className: "modal-body-ui", children: children }), footer && _jsx("div", { className: "modal-footer-ui", children: footer })] }) }));
}
